"use client";

import { useEffect } from "react";

// global-error replaces the root layout when an error is thrown in it, so it
// must render its own <html>/<body>. Styles are inline (the app shell, including
// fonts and globals, is not available here).
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error-boundary]", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FAFAF7",
          color: "#1E1E1E",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          padding: "16px",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "28rem" }}>
          <p style={{ fontSize: "3.5rem", fontWeight: 700, color: "#2D5A3D", margin: "0 0 1rem" }}>
            Oops
          </p>
          <h1 style={{ fontSize: "1.5rem", fontWeight: 700, margin: "0 0 0.75rem" }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: "0.875rem", color: "#666666", margin: "0 0 2rem", lineHeight: 1.6 }}>
            Sorry, the site hit an unexpected error. Please try again.
          </p>
          <button
            onClick={reset}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.75rem 1.5rem",
              backgroundColor: "#2D5A3D",
              color: "#ffffff",
              fontWeight: 600,
              fontSize: "0.875rem",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
